import { msg } from "@lit/localize";
import { createAsyncActionGroup } from "@progressive-development/pd-spa-helper";

import type { BvSitze } from "../service/bv-service.js";
import type { GremiumDrucksachen, Sitzungen } from "../../gremien/service/gremien-service.js";

/**
 * Die zwei eigenen Ladevorgänge der Bezirksvertretungs-Seite.
 *
 * Getrennt, weil sie verschiedene Fragen beantworten und getrennt scheitern
 * dürfen: Wer wissen will, wann die BV tagt, soll das auch dann sehen, wenn
 * die Beschlussliste hakt.
 *
 * Die Nutzlast trägt die GREMIUM-Kennung, nicht den Bezirks-Slug: Gremien
 * kennen ihre eigene Kennung, und die Zuordnung Bezirk → Gremium ist bereits
 * im Verzeichnis erledigt.
 */
export const loadBvSitzungen = createAsyncActionGroup<string, Sitzungen>("LOAD_BV_SITZUNGEN", {
  loadingTxt: msg("Sitzungen werden geladen…", { id: "app.bv.sitzungen.loading.toast" }),
  smallBackground: true,
});

export const loadBvBeschluesse = createAsyncActionGroup<string, GremiumDrucksachen>(
  "LOAD_BV_BESCHLUESSE",
  {
    loadingTxt: msg("Beschlüsse werden geladen…", { id: "app.bv.beschluesse.loading.toast" }),
    smallBackground: true,
  },
);

/**
 * Sitzverteilung und Wahlverfahren.
 *
 * OHNE Nutzlast: Beide Dokumente gelten für alle neun Bezirke zugleich. Sie
 * einmal je Sitzung zu holen genügt — dieselbe Lebensdauer wie die
 * Verzeichnisse, deshalb über `fireOnce` angestoßen.
 */
export const loadBvSitze = createAsyncActionGroup<void, BvSitze>("LOAD_BV_SITZE", {
  loadingTxt: msg("Sitzverteilung wird geladen…", { id: "app.bv.sitze.loading.toast" }),
  smallBackground: true,
});
